import {ComponentFactoryResolver} from '@angular/core';
import {ComponentRef} from '@angular/core';
import {Directive} from '@angular/core';
import {OnDestroy} from '@angular/core';
import {ViewContainerRef} from '@angular/core';

import {BasePortalHost} from './portal';
import {ComponentPortal} from './portal';
import {Portal} from './portal';
import {TemplatePortal} from './portal';

@Directive({ selector: '[cdkPortalHost], [portalHost]' })
export class UIPortalHostDirective extends BasePortalHost implements OnDestroy {

    private _portal: Portal<any>;

    constructor(
        private _componentFactoryResolver: ComponentFactoryResolver,
        private _viewContainerRef: ViewContainerRef) {
        super();
    }

    ngOnDestroy() {
        super.dispose();
        this._portal = null;
    }

    attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T> {
        portal.setAttachedHost(this);

        // If the portal specifies an origin, use that as the logical location of the component
        // in the application tree. Otherwise use the location of this PortalHost.
        const viewContainerRef = portal.viewContainerRef != null ? portal.viewContainerRef : this._viewContainerRef;

        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        const ref = viewContainerRef.createComponent(
            componentFactory, viewContainerRef.length,
            portal.injector || viewContainerRef.parentInjector);

        super.setDisposeFn(() => ref.destroy());
        this._portal = portal;

        return ref;
    }

    attachTemplatePortal(portal: TemplatePortal): void {
        portal.setAttachedHost(this);
        this._viewContainerRef.createEmbeddedView(portal.templateRef);
        super.setDisposeFn(() => this._viewContainerRef.clear());
        this._portal = portal;
    }
}